import { Component } from "react";
import { UserDetails } from "../UserDetails";

import { callBackendAPI, generateSource, cancelToken } from './../helpers/common';
import { WEBSITE_URL, STATUS_SUCCESS} from './../config/global_constants';

export default class ContractProfile extends Component {
    source;

    static contextType = UserDetails;
    componentDidMount() {
        const queryParams 	=	new URLSearchParams(this.props.location.search);
        let contractorPage  =   queryParams.get('page');
        let contractorId    =   queryParams.get('contractor');

        if(!contractorId && !contractorPage) return this.props.history.push('/calendar');

		/** Generate source for cancel token */
		this.source = generateSource();

        callBackendAPI([{ model: 'my_account', method: 'getUserDetails'}],this.source,false).then(response => {
            if(response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].result && response.data[0].result.login_token){
                let URLPrefix = contractorPage || `dashboard` ;
                if(contractorPage && contractorId) URLPrefix += `/${contractorId}`;
                else if(contractorId)  URLPrefix += `?contractor=${contractorId}`;

                window.location.href = `${process.env.REACT_APP_SUBCONTRACTOR_URL}system-login?auth=${response.data[0].result.login_token}&callbackUrl=${URLPrefix}`;
            }else{
                this.props.history.push('/calendar');
            }
        }).catch(err => console.log(err));
    }

    componentWillUnmount(){
        cancelToken(this.source); // cancel the request
    }

    render() {
        return (
            <div className="container mt-5 text-center">
                <img src={`${WEBSITE_URL}loader.gif`} alt="loading" className='position-absolute top-50 left-50 transformxy'/>
            </div>
        );
    }
}